import React from 'react';
import ReactDOM from "react-dom";
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import HelpComponent from '../HelpComponent';

class LidarOption extends React.Component{
    constructor() {
        super();
        this.deleteLayerList = this.deleteLayerList.bind(this);
        this.gotoLayer = this.gotoLayer.bind(this);
        this.state = {
            isSettingOpen : false,
            isEDLOpen : false,
            isAltitudeOpen : false,
            isColorLegendOpen : false,
            displayColorPicker: false,
            EDL:0,
            color: {
                r: '241',
                g: '112',
                b: '19',
                a: '1',
            },
            hexColor:"#F17013",
            AltitudeType : "單色漸層",
            AltitudeMin : 0,
            AltitudeMax : 0,
            helpMode : "None"
        };
    }  
    componentDidMount(){
        let LidarLayer = this.props.layer.layerHandel;
        let AltitudeMin = LidarLayer.getAltitude().AltitudeMin;
        let AltitudeMax = LidarLayer.getAltitude().AltitudeMax;
        this.setState({AltitudeMax:AltitudeMax,AltitudeMin:AltitudeMin});
    }
    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };
    
    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };
    
    handleChange = (color) => {
        let LidarLayer = this.props.layer.layerHandel;
        let AltitudeMin = this.state.AltitudeMin;
        let AltitudeMax = this.state.AltitudeMax;
        let gap = (AltitudeMax - AltitudeMin)/4;
        LidarLayer.setColorSet(
            [
                color.rgb.r, color.rgb.g, color.rgb.b, color.rgb.a,
                color.rgb.r * 0.75, color.rgb.g * 0.75, color.rgb.b * 0.75, color.rgb.a,
                color.rgb.r * 0.5, color.rgb.g * 0.5, color.rgb.b * 0.5, color.rgb.a,
                color.rgb.r * 0.25, color.rgb.g * 0.25, color.rgb.b * 0.25, color.rgb.a,
                0, 0, 0, color.rgb.a, 
            ],
            [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3, AltitudeMax - gap * 4]);
        window.main.OView.updateScreen();
        this.setState({ color: color.rgb,hexColor:color.hex })
    };
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        let LidarLayer = this.props.layer.layerHandel;
        LidarLayer.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    EDLOpen(){
        let LidarLayer = this.props.layer.layerHandel;
        LidarLayer.enableEDL(!this.state.isEDLOpen);
        this.setState({ isEDLOpen: !this.state.isEDLOpen });
    }
    setEDLLevel(event){    
        let LidarLayer = this.props.layer.layerHandel;    
        LidarLayer.edlStrength = event.target.valueAsNumber;
        window.main.OView.updateScreen();
        this.setState({EDL:event.target.valueAsNumber});
    }
    AltitudeOpen(){
        let LidarLayer = this.props.layer.layerHandel;
        let AltitudeMin = this.state.AltitudeMin;
        let AltitudeMax = this.state.AltitudeMax;
        let gap;
        if(this.state.AltitudeType === "單色漸層"){
            gap = (AltitudeMax - AltitudeMin)/4;
            LidarLayer.enableAltitude(!this.state.isAltitudeOpen);
            LidarLayer.setColorSet(
                [
                    this.state.color.r, this.state.color.g, this.state.color.b, this.state.color.a,
                    this.state.color.r * 0.75, this.state.color.g * 0.75, this.state.color.b * 0.75, this.state.color.a,
                    this.state.color.r * 0.5, this.state.color.g * 0.5, this.state.color.b * 0.5, this.state.color.a,
                    this.state.color.r * 0.25, this.state.color.g * 0.25, this.state.color.b * 0.25, this.state.color.a,
                    0, 0, 0, this.state.color.a, 
                ],
                [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3, AltitudeMax - gap * 4]);
            window.main.OView.updateScreen();
            this.setState({ isAltitudeOpen: !this.state.isAltitudeOpen });
        }
        else if(this.state.AltitudeType === "分層設色"){
            gap = (AltitudeMax - AltitudeMin)/3;
            LidarLayer.enableAltitude(!this.state.isAltitudeOpen);
            LidarLayer.setColorSet(
                [
                    255, 0, 0, 255,
                    255, 255, 0, 255,
                    0, 128, 0, 255,
                    0, 0, 0, 255, 
                ],
                [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3]);
            window.main.OView.updateScreen();
            this.setState({ isAltitudeOpen: !this.state.isAltitudeOpen });
        }
    }
    typeChange(event){
        let LidarLayer = this.props.layer.layerHandel;
        let AltitudeMin = this.state.AltitudeMin;
        let AltitudeMax = this.state.AltitudeMax;
        let gap;
        if(event.target.value === "單色漸層"){            
            gap = (AltitudeMax - AltitudeMin)/4;
            LidarLayer.setColorSet(
                [
                    this.state.color.r, this.state.color.g, this.state.color.b, this.state.color.a,
                    this.state.color.r * 0.75, this.state.color.g * 0.75, this.state.color.b * 0.75, this.state.color.a,
                    this.state.color.r * 0.5, this.state.color.g * 0.5, this.state.color.b * 0.5, this.state.color.a,
                    this.state.color.r * 0.25, this.state.color.g * 0.25, this.state.color.b * 0.25, this.state.color.a,
                    0, 0, 0, this.state.color.a, 
                ],
                [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3, AltitudeMax - gap * 4]);
            window.main.OView.updateScreen();
            this.setState({ AltitudeType:event.target.value });
        }
        else if(event.target.value === "分層設色"){            
            gap = (AltitudeMax - AltitudeMin)/3;
            LidarLayer.setColorSet(
                [
                    255, 0, 0, 255,
                    255, 255, 0, 255,
                    0, 128, 0, 255,
                    0, 0, 0, 255, 
                ],
                [AltitudeMax, AltitudeMax - gap, AltitudeMax - gap * 2, AltitudeMax - gap * 3]);
            window.main.OView.updateScreen();
            this.setState({ AltitudeType:event.target.value });
        }
    }
    ColorLegendOpen= () => {
        this.setState({ isColorLegendOpen: !this.state.isColorLegendOpen })
    };
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const Layer = this.props.layer;
        const AltitudeMin = this.state.AltitudeMin;
        const AltitudeMax = this.state.AltitudeMax;
        const gap = (AltitudeMax - AltitudeMin)/3;
        let ColorLegend = null;        
        if(this.state.isSettingOpen&&this.state.isAltitudeOpen&&this.state.AltitudeType === "分層設色"&&this.state.isColorLegendOpen){
            ColorLegend = (
                <div className="ts grid">
                    <div id='ColorLegend'>
                        <div id='ColorLegendbox'>
                            <div id='ColorLegendTitle'>
                                圖例(單位：公尺)
                            </div>
                            <div id='ColorLegendbody'>
                                <div id="ColorLegendbodyRed"></div>
                                <div style={{padding:"2px"}}>
                                    {
                                        Math.round(AltitudeMax - gap - AltitudeMin) + "~" + Math.round(AltitudeMax - AltitudeMin)
                                    }
                                </div>
                            </div>
                            <div id='ColorLegendbody'>
                                <div id="ColorLegendbodyYello"></div>
                                <div style={{padding:"2px"}}>
                                    {
                                        Math.round(AltitudeMax - gap*2 - AltitudeMin) + "~" + Math.round(AltitudeMax - gap - AltitudeMin)
                                    }
                                </div>
                            </div>
                            <div id='ColorLegendbody'>
                                <div id="ColorLegendbodyGreen"></div>
                                <div style={{padding:"2px"}}>
                                    {
                                        Math.round(AltitudeMax - gap*3 - AltitudeMin) + "~" + Math.round(AltitudeMax - gap*2 - AltitudeMin)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );     
        }
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        const styles = reactCSS({
            'default': {
                color: {
                    width: '155px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'fixed',
                    zIndex: '2000'
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        if(this.state.helpMode === "LidarHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/xfw1DDbKyRk" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large cloud icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("LidarHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen?
                        <div className="ts very narrow container segment" >
                            <div className="ts grid">
                                <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                    <h6 className="layerNameCSS">邊界增強模式：</h6>
                                </div>
                                <div className="ts six wide column">
                                    <div class="ts toggle checkbox">
                                        <input type="checkbox" id={Layer.layerName + "EDLtoggle"} checked={this.state.isEDLOpen} onClick={(e)=>this.EDLOpen()}></input>
                                        <label for={Layer.layerName + "EDLtoggle"}></label>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.isEDLOpen?
                                <div>                    
                                    <input type="range" min="0" max="100" defaultValue={this.state.EDL} step="1" style={siderRangeCSS} onChange={(e)=>this.setEDLLevel(e)}></input>
                                </div> : null
                            }
                            

                            <div className="ts grid">
                                <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                    <h6 className="layerNameCSS">高度著色模式：</h6>
                                </div>
                                <div className="ts six wide column">
                                    <div class="ts toggle checkbox">
                                        <input type="checkbox" id={Layer.layerName + "Altitudetoggle"} checked={this.state.isAltitudeOpen} onClick={(e)=>this.AltitudeOpen()}></input>
                                        <label for={Layer.layerName + "Altitudetoggle"}></label>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.isAltitudeOpen?
                                    <div className="ts grid">
                                        <div className="ts eight wide column" >
                                        <select className="ts borderless basic dropdown" onChange={(e)=>this.typeChange(e)} value={this.state.AltitudeType}>
                                            <option value="單色漸層">單色漸層</option>
                                            <option value="分層設色">分層設色</option>
                                        </select>
                                        </div>
                                        <div className="ts eight wide column" style={{alignSelf: 'center'}}>
                                            {
                                                this.state.AltitudeType === "單色漸層"?
                                                <div style={{textAlign: 'center'}}>
                                                    <div style={ styles.swatch } onClick={ this.handleClick }>
                                                        <div style={ styles.color } />
                                                    </div>
                                                    { 
                                                        this.state.displayColorPicker ? 
                                                            <div style={ styles.popover }>
                                                                <div style={ styles.cover } onClick={ this.handleClose }/>
                                                                    <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
                                                                </div> : null 
                                                    }
                                                </div> :
                                                <div style={{textAlign: 'center'}}>
                                                    <button class="ts link button" onClick={this.ColorLegendOpen}>{this.state.isColorLegendOpen?'關閉分層設色圖例':'開啟分層設色圖例'}</button>
                                                </div>  
                                            }                                            
                                        </div>
                                    </div> : null
                            }
                            {ColorLegend}
                        </div> : null
                }
            </div>
        );
    }
}

class LidarLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            lidarLayer:{}
        };   
        this.lidarLayerChecked = this.lidarLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.lidarLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,lidarLayer:{}});
            }            
        }
    }
    lidarLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            window.main.OView.addPointCloudLayer({
                url: window.TERRAIN_SERVER.URL,
                identifier: layer.ID,
                urlTemplate: window.TERRAIN_SERVER.URLTemplate,
                callback: function (e,lidarLayer) {
                    if(e){
                        lidarLayer._layer.UrlManager.SetTemplate(window.TERRAIN_SERVER.URLTemplate);
                        lidarLayer.goto();
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,lidarLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,lidarLayer:lidarLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });      
        }
        else{
            window.main.OView.removeLayer(this.state.lidarLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,lidarLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="LidarLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.lidarLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {LidarLayer,LidarOption};